export const PRODUCT_DETAIL_FACE_WIDTH_PROMPT_STORAGE_KEY =
  'zeelool:face-width-product-detail-prompt:v1';
export const PRODUCT_DETAIL_FACE_WIDTH_PROMPT_DISMISS_MS = 24 * 60 * 60 * 1000;

interface ProductDetailPromptDismissal {
  hiddenUntil: number;
}

function parseProductDetailPromptDismissal(
  value: string | null,
): ProductDetailPromptDismissal | null {
  if (!value) return null;

  try {
    const parsed: unknown = JSON.parse(value);
    if (
      typeof parsed !== 'object' ||
      parsed === null ||
      !('hiddenUntil' in parsed) ||
      typeof parsed.hiddenUntil !== 'number' ||
      !Number.isFinite(parsed.hiddenUntil)
    ) {
      return null;
    }

    return { hiddenUntil: parsed.hiddenUntil };
  } catch {
    return null;
  }
}

export function isProductDetailFaceWidthPromptDismissed(
  storage: Pick<Storage, 'getItem'>,
  now = Date.now(),
) {
  try {
    const dismissal = parseProductDetailPromptDismissal(
      storage.getItem(PRODUCT_DETAIL_FACE_WIDTH_PROMPT_STORAGE_KEY),
    );
    return dismissal ? dismissal.hiddenUntil > now : false;
  } catch {
    return false;
  }
}

export function dismissProductDetailFaceWidthPrompt(
  storage: Pick<Storage, 'setItem'>,
  now = Date.now(),
) {
  try {
    storage.setItem(
      PRODUCT_DETAIL_FACE_WIDTH_PROMPT_STORAGE_KEY,
      JSON.stringify({ hiddenUntil: now + PRODUCT_DETAIL_FACE_WIDTH_PROMPT_DISMISS_MS }),
    );
    return true;
  } catch {
    return false;
  }
}
